export default [
  {
    header: 'Adherents',
    rights: [
      'ENTREPRISES:read',
      'EXTERNES_ENTREPRISES_OPENSOME:read'
    ]
  },
  {
    title: 'Gérer les adhérents',
    icon: 'BriefcaseIcon',
    route: 'adherents',
    rights: [
      'ENTREPRISES:read',
      'EXTERNES_ENTREPRISES_OPENSOME:read'
    ]
  },
  {
    title: 'Kanban des opportunités',
    icon: 'GridIcon',
    route: 'kanban-opportunites',
    rights: [
      'ENTREPRISES_OPPORTUNITES:read'
    ]
  },

  {
    title: 'Liste des opportunités',
    icon: 'ListIcon',
    route: 'list-opportunites',
    rights: [
      'ENTREPRISES_OPPORTUNITES:read'
    ]
  },
]
